/** Google Calendar booking (Dankore Software Calendar). */
export const BOOKING_URL = 'https://calendar.app.google/msJbv4Hgt9Aavme97';

/** General support inbox (mailto buttons site-wide). */
export const CONTACT_EMAIL = 'support@yeswecanhq.com';

/** E.164; used for `tel:` and WhatsApp (`wa.me`). */
export const CONTACT_PHONE_E164 = '+13192965799';

/** Shown next to phone actions for readability. */
export const CONTACT_PHONE_LABEL = '+1 (319) 296-5799';

/** WhatsApp chat (same number as `CONTACT_PHONE_E164`). */
export function contactWhatsAppUrl(): string {
  return `https://wa.me/${CONTACT_PHONE_E164.replace(/\D/g, '')}`;
}

/** Voice call / native dialer (same number as WhatsApp). */
export function contactTelUrl(): string {
  return `tel:${CONTACT_PHONE_E164}`;
}

/** Public Facebook page (also in site footer). */
export const FACEBOOK_PAGE_URL = 'https://www.facebook.com/yeswecanllc/';
